export const formatForSelect = (dataToFormat) => {
  let selectData = [];
  dataToFormat.sort(({ id: a }, { id: b }) => a - b);
  dataToFormat.forEach((value) => {
    selectData.push({
      key: value.id,
      text: value.name,
      value: {
        id: value.id,
        name: value.name,
        detailsRequired: value.detailsRequired,
        policeIncident: value.policeIncident,
      },
    });
  });
  return selectData;
};

export const formatForSubmit = (array, value) => {
  const object = array.filter((obj) => {
    return obj.value === value;
  })[0];
  return {
    id: object.value,
    name: object.text,
  };
};
